import { FieldState } from "formstate";
import React from "react";
import { EditInputFieldState } from "@fidget/common/components/form/editInput";
import { intl } from "@fidget/common/i18n/TypedIntl";
import settingsStyles from "../../../../../styles/settings.css";
import { staticConfig } from "@fidget/common/config/static-config";

interface Props {
  field: FieldState<string>;
}

export const AdviserGroupNameInput = ({ field }: Props) => {
  return (
    <EditInputFieldState
      className={settingsStyles["input-width"]}
      field={field}
      placeholder={intl.formatMessage("settings.adviserGroups.form.group.placeholder")}
      maxLength={staticConfig.agentGroupNameMaxCharacters}
    />
  );
};
